import { render, staticRenderFns } from "./PlaceDetails.vue?vue&type=template&id=7d970e08&scoped=true"
import script from "./PlaceDetails.vue?vue&type=script&lang=js"
export * from "./PlaceDetails.vue?vue&type=script&lang=js"
import style0 from "./PlaceDetails.vue?vue&type=style&index=0&id=7d970e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d970e08",
  null
  
)

export default component.exports